<template>
    <MiniModalCustom :is-open="props.isOpen" @close="emit('close')">
        <div v-html="notes" class="ql-editor"></div>
    </MiniModalCustom>
</template>
<script setup>
import { computed, defineProps, defineEmits } from "vue";

const emit = defineEmits(["close"]);

const props = defineProps({
    isOpen: {
        type: Boolean,
    },
    notes: {
        type: String,
    },
});

const notes = computed(() => (props.notes === "null" ? "" : props.notes));
</script>
